import { render, staticRenderFns } from "./StatusNumberChip.vue?vue&type=template&id=4bd0ef9e&scoped=true&"
import script from "./StatusNumberChip.vue?vue&type=script&lang=js&"
export * from "./StatusNumberChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0ef9e",
  null
  
)

export default component.exports